




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'


import DigitalCurrency1DigitalCurrencySymbol from './digital-currency-1-digital-currency-symbol.vue'
import UserInterface7LargeNumberDisplay from '../basic-type-4-user-interface/user-interface-7-large-number-display.vue'

import { getNumberWithFixedDecmial1 } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-9-get-number-with-fixed-decimal/get-number-with-fixed-decimal-1'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { getTimeUntilMillisecondDurationReached } from './service-for-helper-algorithms/helper-algorithms-4-get-time-until-millisecond-duration-reached'


@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol,
    UserInterface7LargeNumberDisplay
  }
})
class DigitalCurrency20AnimatedCurrencyLabel extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean
  @Prop({ default: () => { return {} } }) currencyAmountAndAccountId?: any
  @Prop({ default: false }) isDigitalCurrencyAccountUpdate?: boolean
  @Prop({ default: true }) showVerticalUpdateList?: boolean
  @Prop({ default: true }) showSinceTimeUpdate?: boolean
  @Prop({ default: false }) showNumberOfTransactions?: boolean
  @Prop({ default: false }) showTransactionTextAbbreviated?: boolean
  @Prop({ default: 6 }) maximumNumberOfUnitPlaces?: number
  @Prop({ default: 2 }) maximumNumberOfDecimalPlaces?: number
  @Prop({ default: false }) useENotation?: boolean

  digitalCurrencyName = projectVariables.digitalCurrencyName

  showCurrencyUpdateList: boolean = true

  currencyUpdateDifferenceForIncreaseList: Array<{ updateDifferenceAmount: number, dateUpdateCreated: number }> = []
  currencyUpdateDifferenceForDecreaseList: Array<{ updateDifferenceAmount: number, dateUpdateCreated: number }> = []

  hasUpdatedFirstValue: boolean = false
  millisecondDelayToShowAmountUpdate: number = 10 * 1000

  hideUpdateIncreaseListTimeoutId: any = null
  hideUpdateDecreaseListTimeoutId: any = null

  get summationOfTotalCurrencyAmountForUpdateIncreaseList () {
    const updateDifferenceIncreaseList = this.currencyUpdateDifferenceForIncreaseList.map((updateDifferenceForIncrease) => updateDifferenceForIncrease.updateDifferenceAmount)
    if (updateDifferenceIncreaseList.length === 0) {
      return 0
    }
    const summationTotal = updateDifferenceIncreaseList.reduce((a, b) => getNumberWithFixedDecmial1(a + b))
    return summationTotal
  }

  get summationOfTotalCurrencyAmountForUpdateDecreaseList () {
    const updateDifferenceDecreaseList = this.currencyUpdateDifferenceForDecreaseList.map((updateDifferenceForDecrease) => updateDifferenceForDecrease.updateDifferenceAmount)
    if (updateDifferenceDecreaseList.length === 0) {
      return 0
    }
    const summationTotal = updateDifferenceDecreaseList.reduce((a, b) => getNumberWithFixedDecmial1(a + b))
    return summationTotal
  }

  get timeAgoSinceEarliestUpdateIncrease () {
    if (this.currencyUpdateDifferenceForIncreaseList.length === 0) {
      return ''
    }
    const millisecondTimeAgoSinceNow = (new Date()).getTime() - this.currencyUpdateDifferenceForIncreaseList[0].dateUpdateCreated
    return getTimeUntilMillisecondDurationReached(millisecondTimeAgoSinceNow) + ' ago'
  }

  get timeAgoSinceEarliestUpdateDecrease () {
    if (this.currencyUpdateDifferenceForDecreaseList.length === 0) {
      return ''
    }
    const millisecondTimeAgoSinceNow = (new Date()).getTime() - this.currencyUpdateDifferenceForDecreaseList[0].dateUpdateCreated
    return getTimeUntilMillisecondDurationReached(millisecondTimeAgoSinceNow) + ' ago'
  }

  @Watch('currencyAmountAndAccountId') onUpdateCurrencyAmountAndAccountId (newValue: any, oldValue: any) {
    if (!this.hasUpdatedFirstValue) {
      this.hasUpdatedFirstValue = true
      return
    }

    if (!newValue || !oldValue) {
      return
    }

    if (newValue.accountId !== oldValue.accountId) {
      return
    }

    const currentDate = (new Date()).getTime()

    newValue = { currencyAmount: getNumberWithFixedDecmial1(newValue.currencyAmount), ...newValue }
    oldValue = { currencyAmount: getNumberWithFixedDecmial1(oldValue.currencyAmount), ...oldValue }

    const currencyUpdateDifferenceAmount = getNumberWithFixedDecmial1(newValue.currencyAmount - oldValue.currencyAmount)
    const currencyUpdateObject = { updateDifferenceAmount: currencyUpdateDifferenceAmount, dateUpdateCreated: currentDate }

    if (currencyUpdateDifferenceAmount === 0) {
      return
    }

    if (currencyUpdateDifferenceAmount > 0) {
      this.currencyUpdateDifferenceForIncreaseList.push(currencyUpdateObject)
    } else if (currencyUpdateDifferenceAmount < 0) {
      this.currencyUpdateDifferenceForDecreaseList.push(currencyUpdateObject)
    }

    if (currencyUpdateDifferenceAmount > 0) {
      clearTimeout(this.hideUpdateIncreaseListTimeoutId)
      this.hideUpdateIncreaseListTimeoutId = setTimeout(() => {
        this.currencyUpdateDifferenceForIncreaseList = []
        this.hideUpdateIncreaseListTimeoutId = null
      }, this.millisecondDelayToShowAmountUpdate)
    }

    if (currencyUpdateDifferenceAmount < 0) {
      clearTimeout(this.hideUpdateDecreaseListTimeoutId)
      this.hideUpdateDecreaseListTimeoutId = setTimeout(() => {
        this.currencyUpdateDifferenceForDecreaseList = []
        this.hideUpdateDecreaseListTimeoutId = null
      }, this.millisecondDelayToShowAmountUpdate)
    }

    if (this.currencyUpdateDifferenceForIncreaseList.length > 0) {
      if (currentDate - this.currencyUpdateDifferenceForIncreaseList[0].dateUpdateCreated >= 2 * this.millisecondDelayToShowAmountUpdate) {
        this.currencyUpdateDifferenceForIncreaseList = this.currencyUpdateDifferenceForIncreaseList.slice(Math.floor(this.currencyUpdateDifferenceForIncreaseList.length / 2), this.currencyUpdateDifferenceForIncreaseList.length)
      }
    }

    if (this.currencyUpdateDifferenceForDecreaseList.length > 0) {
      if (currentDate - this.currencyUpdateDifferenceForDecreaseList[0].dateUpdateCreated >= 2 * this.millisecondDelayToShowAmountUpdate) {
        this.currencyUpdateDifferenceForDecreaseList = this.currencyUpdateDifferenceForDecreaseList.slice(Math.floor(this.currencyUpdateDifferenceForDecreaseList.length / 2), this.currencyUpdateDifferenceForDecreaseList.length)
      }
    }
  }

  destroyed () {
    clearTimeout(this.hideUpdateIncreaseListTimeoutId)
    clearTimeout(this.hideUpdateDecreaseListTimeoutId)
  }
}

export default DigitalCurrency20AnimatedCurrencyLabel

